// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hXJ3s9CRcTU981b4sb0n{flex-direction:column;gap:12px;margin-top:24px;display:flex}.MGA8LRhcE0sxdXzuc4z4{cursor:pointer;align-items:center;gap:8px;width:-webkit-fit-content;width:fit-content;padding:6px 0;display:flex}.D8PlL3SUGqUgx_6jRQNd{border:1px solid var(--black-10);background:var(--background-primary-inverted-primary);border-radius:4px;padding:0 4px 2px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scopesSection": `hXJ3s9CRcTU981b4sb0n`,
	"scopeItem": `MGA8LRhcE0sxdXzuc4z4`,
	"scopeLabel": `D8PlL3SUGqUgx_6jRQNd`
};
export default ___CSS_LOADER_EXPORT___;
